import { NgModule } from "@angular/core";
import { SharedModule } from "../../../shared/shared.module";

import { ProfileRoutingModule } from "./profile-routing.module";
import { ProfileComponent } from "./profile.component";
import { ProfileNavTabsComponent } from "./profile-nav-tabs/profile-nav-tabs.component";
import { CreatedDiscussionsComponent } from "./created-discussions/created-discussions.component";
import { VotedDiscussionsComponent } from "./voted-discussions/voted-discussions.component";
import { BookmarkedDiscussionsComponent } from "./bookmarked-discussions/bookmarked-discussions.component";
import { ProfileCardComponent } from "./profile-card/profile-card.component";
import { ProfileResolver } from "../../../shared/services";

@NgModule({
  imports: [ProfileRoutingModule, SharedModule],
  declarations: [
    ProfileComponent,
    ProfileNavTabsComponent,
    CreatedDiscussionsComponent,
    VotedDiscussionsComponent,
    BookmarkedDiscussionsComponent,
    ProfileCardComponent,
  ],
  providers: [ProfileResolver],
})
export class ProfileModule {}
